import { useState } from "react";
import { BellRing } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function AlertsToggle() {
  const { user, setUser } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!user) return null;
  const onChange = async (enabled) => {
    setBusy(true);
    try {
      await api.put("/me/alerts", { enabled });
      setUser((u) => ({ ...u, alerts_enabled: enabled }));
      toast.success(enabled ? `Alerts on. We'll email ${user.email}` : "Alerts turned off");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div data-testid="alerts-panel" className="panel mt-6 flex items-center gap-4 p-5">
      <BellRing className="shrink-0 text-[#fde68a]" size={22} />
      <div className="flex-1">
        <p className="font-semibold text-white">Happy Hour Alerts</p>
        <p className="text-sm text-zinc-400">Get an email 30 minutes before any of your saved spots' happy hours start.</p>
      </div>
      <Switch data-testid="alerts-toggle" aria-label="Email me happy hour alerts" className="data-[state=unchecked]:bg-zinc-600" checked={!!user.alerts_enabled} disabled={busy} onCheckedChange={onChange} />
    </div>
  );
}
